<template>
  <div class="message-content">
    <div v-if="show_data">
    <div v-show="!showPollResults">
      <div class="row mt-4">
        <div class="col-12">

          <div v-if="isResponseForMsg && !this.user.parent && !this.messageContent.answers[0].sender.teacher || isResponseForMsg && this.user.parent && this.messageContent.answers[0].sender.teacher" class="message-responds btn-cursor px-4 py-3">

            <a v-if="messageContent.answers.length === 1" v-b-modal.modal-one-message @click="openReply">
              <div class="single-respond">
                <!-- <h3 v-if="!messageContent.received">{{ messageContent.answers[0].confirmed_by.title }}</h3> -->
                <h3>{{ messageContent.answers[0].sender.title }}</h3>
                <h4 class="mb-0">{{ messageContent.answers[0].date | formatDate }}</h4>
                <img v-if="this.messageContent.answers[0].unread" class="respond-icon" :src="'./static/img/' + user.role +'/first_message.png'" alt="">
                <img v-else class="respond-icon" :src="'./static/img/' + user.role +'/first_message_unreaded.png'" alt="">
              </div>
            </a>

            <router-link v-else :to="{ name: 'responds', params: { id: messageContent.itemid} }">
              <div class="multiple-responds">
                <h3 class="mb-0">Alle Antworten anzeigen</h3>
                <img class="respond-icon" :src="'./static/img/' + user.role +'/first_message.png'" alt="">
              </div>
            </router-link>

            <b-modal size="md" id="modal-one-message" centered class="app-modals" hide-footer>
              <div slot="modal-title" class="w-100">
                <span v-if="!messageContent.received">Von: {{ messageContent.answers[0].sender.subtitle }}</span>
                <span v-else>Von: {{ messageContent.answers[0].sender.title }}</span>
              </div>
              <twemoji class="message-detail" :content="messageContent.answers[0].message" v-linkified/>
            </b-modal>

          </div>

        </div>
      </div>


      <div class="row mt-4">
        <div class="col-6">
          <h1 class="message-title">
            <twemoji :content="messageContent.title" v-linkified/>
          </h1>
          <h3 class="message-date">{{ messageContent.date | formatDate }}</h3>
        </div>
        <div class="col-6">
          <div class="message-actions d-flex align-items-center justify-content-end text-right">
            <div class="position-relative pdf-loading-spinner">
              <div slot="spinner"><clip-loader :loading="pdfExporting" :color="'grey'" :size="'30px'"></clip-loader></div>
              <b-link v-if="!user.isParent() && !pdfExporting" v-b-modal.modal-pdf-export><img class="ml-4" :src="'./static/img/' + user.role +'/pdf_icon.png'" alt=""></b-link>
              <b-link v-if="user.isParent() && !pdfExporting"  @click="exportPdfMessage(messageContent.id)"><img class="ml-4" :src="'./static/img/' + user.role +'/pdf_icon.png'" alt=""></b-link>
            </div>
            <router-link v-if="messageContent.confirmation && user.role === 'lehrer'" :to="{ name: 'confirmations', params: { id: messageContent.itemid} }">
              <img class="ml-1" :src="'./static/img/' + user.role +'/nav_answer.png'" alt="">
            </router-link>
            <img v-if="user.isParent()" @click="translate()" class="respond-icon btn-cursor" src="~assets/img/translate_icon.png" alt="">
            <img v-if="!messageContent.my_close_status" @click="setOpenStatus(false)" class="ml-1 btn-cursor set-done-icon" :src="'./static/img/' + user.role +'/icon_done.png'" alt="">
            <img v-else @click="setOpenStatus(true)" class="ml-1 btn-cursor set-done-icon" :src="'./static/img/' + user.role +'/icon_open.png'" alt="">
          </div>
        </div>
      </div>
      <b-modal ref="modalPdfExport" size="md" id="modal-pdf-export" centered class="app-modals" title="Nachricht als PDF archivieren..." hide-footer>
        <div class="action" v-if="messageContent.selected_receivers !== undefined && messageContent.selected_receivers !== null && messageContent.selected_receivers[0] && !messageContent.selected_receivers[0].teacher" @click="exportPdfLetter()">
          <h3>Elternbrief herunterladen</h3>
          <p>Erzeugen Sie aus dieser Nachricht eine PDF-Datei zum Ausdrucken.</p>
        </div>
        <div class="action" @click="exportPdfMessage(messageContent.id)">
          <h3>Nachricht herunterladen</h3>
          <p>Speichern Sie eine PDF-Datei dieser Nachricht inkl. Antworten, Bestätigungen und Abstimmungsergebnissen.</p>
        </div>
      </b-modal>
      <div class="row mt-3">
        <div class="col-4">
          <h5 class="message-uptitle">Betreff:</h5>
          <h4 class="message-detail">
            <twemoji :content="messageContent.title" v-linkified/>
          </h4>
        </div>
        <div class="col-4">
          <h5 class="message-uptitle">Gesendet von:</h5>
          <h4 class="message-detail">{{ messageContent.sender.title }}</h4>
        </div>
        <div class="col-4">
          <h5 class="message-uptitle">Gesendet an:</h5>
          <h4 v-if="messageContent.all_students" class="message-detail mb-0">
            Alle Schüler
          </h4>
          <h4 v-else-if="messageContent.received && user.parent" v-for="parentReceiver in pinboard.users" class="message-detail mb-0">
            {{ parentReceiver.firstname }} {{ parentReceiver.lastname }}
          </h4>
          <h4 v-else v-for="receiver in messageContent.selected_receivers" class="message-detail mb-0">
            {{ receiver.title }}
          </h4>
        </div>
      </div>

      <div v-if="messageContent.sick" class="row mt-3">
        <div class="col-12">
          <h5 class="message-uptitle">Abwesend ab:</h5>
          <div class="message-text">
            {{ messageContent.date_absent | absentDate }}
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div v-if="messageContent.message" class="col-12">
          <h5 class="message-uptitle">Nachricht:</h5>
          <div class="message-detail">
            <twemoji :content="messageContent.message" v-linkified/>
          </div>
          <div v-if="translatedContent" class="message-translation mt-2">
            <h5 class="message-uptitle">Übersetzung ({{ translateTarget.name }}):</h5>
            <twemoji :content="translatedContent" v-linkified/>
          </div>
        </div>
      </div>

      <div v-if="user.parent && messageContent.confirmed || isResponseForMsg && !this.user.parent && this.messageContent.answers[0].sender.teacher" class="row mt-3">
        <div class="col-12">

          <div v-if="messageContent.confirmation">
            <h5 class="message-uptitle" v-if="isResponseOwner">
              Bestätigt von mir, am {{ messageContent.answers[0].date | formatDate }}
            </h5>
            <h5 class="message-uptitle" v-else>
              Bestätigt von {{ messageContent.answers[0].sender.title }}, {{ messageContent.answers[0].date | formatDate }}
            </h5>
          </div>

          <div v-else-if="messageContent.pool">
            <div class="row mt-3">
              <div class="col-12 mb-2">
                <div v-for="option in messageContent.options" class="poll-answer-option-tile" :class="{ checked: option.chosen }">
                  <twemoji :content="option.title"/>
                </div>
              </div>
            </div>
            <h5 class="message-uptitle" v-if="isResponseOwner">
              Abgestimmt von mir, am {{ messageContent.answers[0].date | formatDate }}
            </h5>
            <h5 class="message-uptitle" v-else>
              Abgestimmt von {{ messageContent.answers[0].sender.title }}, am {{ messageContent.answers[0].date | formatDate }}
            </h5>
          </div>

          <div v-else-if="!messageContent.confirmation && !messageContent.pool">
            <h5 class="message-uptitle" v-if="isResponseOwner">
              Antwort von mir, am {{ messageContent.answers[0].date | formatDate }}
            </h5>
            <h5 class="message-uptitle" v-else>
              Antwort von {{ messageContent.answers[0].sender.title }}, am {{ messageContent.answers[0].date | formatDate }}
            </h5>
          </div>

          <div v-if="!messageContent.pool && messageContent.answers[0].message !== ''" v-b-modal.modal-show-answer class="show-dialog-answer">
            <h5 class="message-uptitle d-inline btn-cursor" v-if="isResponseOwner">
              Meine Antwort lesen
            </h5>
            <h5 class="message-uptitle d-inline btn-cursor" v-else>
              Antwort lesen
            </h5>
          </div>

          <b-modal v-if="!messageContent.pool" ref="modalShowAnswer" id="modal-show-answer" size="md" centered class="app-modals" hide-footer>
            <div slot="modal-title" class="w-100">
              {{ messageContent.answers[0].sender.title }}
            </div>
            <twemoji class="message-detail" :content="messageContent.answers[0].message" v-linkified/>
          </b-modal>

        </div>
      </div>

      <b-modal ref="modalTranslationDialog" id="modal-translation-dialog" size="md" centered class="app-modals" hide-header hide-footer>
        <h4 class="modal-title text-center m-4">Sie müssen in den Einstellungen erst eine Sprache für die Übersetzung auswählen.</h4>
        <div class="modal-controls d-flex flex-direction-row">
          <button @click="closeModal()" class="btn btn-neue w-100 mx-2">Abbrechen</button>
          <router-link :to="{ name: 'settings' }" class="btn btn-neue w-100 mx-2">Einstellungen</router-link>
        </div>
      </b-modal>

      <div v-if="messageContent.pool && !messageContent.received" class="row mt-3">
        <div class="col-12">
          <h5 class="message-uptitle">{{ messageContent.confirmed }} von {{ messageContent.selected_receivers.length }} haben abgestimmt</h5>
        </div>
      </div>

      <div v-if="messageContent.sick" class="row mt-3">
        <div class="col-12">
          <h5 class="message-uptitle">
            Diese Nachricht wird aus datenschutzrechtlichen Gründen nur noch {{ messageContent.nr_days_shown }}
            <span v-if="messageContent.nr_days_shown > 1">Tage</span>
            <span v-else>Tag</span>
            angezeigt.
          </h5>
        </div>
      </div>

      <div class="separator mt-4 mb-4 mx-auto w-50"></div>



      <div v-if="messageContent.pool && !messageContent.received" class="row mb-2">
        <div class="col-12">
          <div v-for="option in messageContent.options" @click="setPollResults(option)" class="poll-option-tile btn-cursor">
            <span class="poll-option-number">{{ option.contacts.length }}</span>
            <twemoji :content="option.title" v-linkified/>
<!--            {{ option.title }}-->
            <img v-if="option.contacts.length > 0" class="poll-option-arrow" :src="'./static/img/' + user.role +'/arrow_right.png'" alt="">
          </div>
        </div>
      </div>
      <!-- TODO -->
      <div v-if="messageContent.pool && messageContent.received && !messageContent.confirmed_by" class="row mb-2">
        <div v-if="!messageContent.closed" class="col-12 mb-1">
          <h5 v-if="messageContent.multiple_choice" class="poll-vote-type">Bitte stimmen Sie ab (Mehrfachantwort möglich)</h5>
          <h5 v-else class="poll-vote-type">Bitte stimmen Sie ab (Einzelantwort möglich)</h5>
        </div>
        <div v-if="!messageContent.closed" class="col-12 mb-2">
          <div v-for="option in messageContent.options" @click="selectAnswer(option.itemid)" class="poll-answer-option-tile btn-cursor" :class="{ checked: selectedAnswers.includes(option.itemid) }">
            <div class="option-picker" :for="option.itemid">
              <input :id="option.itemid" :checked="selectedAnswers.includes(option.itemid)" type="checkbox" :value="option.itemid">
              <label ></label>
            </div>
            <twemoji :content="option.title" v-linkified/>
          </div>
        </div>
        <div v-if="!messageContent.closed" class="col-12 mb-2 text-right">
          <button @click="sendPollAnswer" class="btn btn-neue" :disabled="this.selectedAnswers.length === 0">
            <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
            <span v-show="!processing">Absenden</span>
          </button>
        </div>
        <div class="col-12 mb-2 text-right">
          <span v-if="messageContent.closed">
            <p style="color: red">
              Abstimmung nicht mehr möglich. Die Nachricht wurde vom Sender geschlossen.
            </p>
          </span>
        </div>
      </div>



      <div v-if="messageContent.link" class="row mt-2 mb-4">
        <div class="col-12">
          <a v-bind:href="messageContent.link" target="_blank">
            <div v-if="messageContent.filename_client" class="message-attachment px-3 py-2 d-flex">
              <img v-if="messageContent.filename_client.includes('pdf')" :src="'./static/img/' + user.role +'/pdf_icon.png'" alt="">
              <img v-else-if="messageContent.filename_client.includes('jpg', 'jpeg', 'png')" :src="'./static/img/' + user.role +'/image_hdpi.png'" alt="">
              <img v-else :src="'./static/img/' + user.role +'/file_hdpi.png'" alt="">
              <div class="message-attachment-details ml-3 d-flex flex-column justify-content-center">
                <h2 class="mb-0">{{ messageContent.filename_client }}</h2>
              </div>
              <img class="attach-icon" :src="'./static/img/' + user.role +'/attachment.png'" alt="">
            </div>
          </a>
        </div>
      </div>

      <div v-if="answerHasMessage" class="row mb-2">
        <div class="col-12 mb-1 text-right">
          <div v-if="true">
          <button v-if="!messageContent.closed  && messageContent.messageType === 2" v-b-modal.modal-answer-message @click="showAnswerTextarea = false" class="btn btn-neue">
            <span>Bestätigen</span>
          </button>
          <span v-if="messageContent.closed  && messageContent.messageType === 2">
            <p style="color: red">
              Bestätigung nicht mehr möglich. Die Nachricht wurde vom Sender geschlossen.
            </p>
          </span>
          </div>

          <button v-if="this.messageContent.answer_allowed && !messageContent.closed  && messageContent.messageType != 2" v-b-modal.modal-answer-message @click="showAnswerTextarea = true" class="btn btn-neue">
            <span>Antwort</span>
          </button>
          <span v-if="messageContent.closed  && messageContent.messageType != 2">
            <p style="color: red">
              Antwort nicht mehr möglich. Die Nachricht wurde vom Sender geschlossen.
            </p>
          </span>
        </div>
      </div>
      </div>



    <b-modal @change="clearModal"
      ref="modalAnswerMessage"
      size="sm"
      id="modal-answer-message"
      centered class="app-modals"
      title="Auf die Nachricht antworten"
      hide-footer>
      <div v-if="!showAnswerTextarea" class="answer-actions mb-2">
        <div class="mb-2">Ich bestätige, dass ich diese Mitteilung gelesen und zur Kenntnis genommen habe...</div>
        <button @click="showAnswerTextarea = true" v-if="messageContent.answer_allowed" class="btn btn-neue w-100 my-1">Bestätigen mit Antwort</button>
        <button @click="sendAnswer" class="btn btn-neue w-100 my-1">Bestätigen ohne Antwort</button>
      </div>
      <div v-if="showAnswerTextarea" class="answer-message text-center">
        <textarea v-model="answer.message" class="form-control mb-3" placeholder="Nachricht" rows="5" maxlength="3000"></textarea>
        <p class="text-right light-grey">{{ answer.message | charsLeft(3000) }}</p>
        <button @click="sendAnswer" variant="primary" class="btn-gradient" :disabled="!answer.message.length > 0">
          <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
          <span v-show="!processing">Senden</span>
        </button>
      </div>
    </b-modal>

    <poll-result v-show="showPollResults" :option="selectedOption" @back="showPollResults = false"/>

  </div>
  </div>
</template>

<script>
// API
import messageApi from '@/api/v1/messages';
import pinboardApi from '@/api/v1/pinboard';
// Components
import Alert from '@/components/Helpers/Alert';
import PollResult from '@/components/Messages/Show/PollResult';
// mixins
import alert from '@/mixins/alert';

let refreshMessageIntervalId = 0;

export default {
  components: { Alert, PollResult },
  mixins: [alert],
  data() {
    return {
      user: this.$current_user,
      selectedOption: {},
      messageContent: {
        title: '',
        sender: {},
        closed: false,
        message: '',
      },
      answer: {
        message: '',
      },
      showPollResults: false,
      selectedAnswers: [],
      processing: false,
      showAnswerTextarea: false,
      pinboard: {},
      answerText: '',
      error: '',
      show_data:true,
      translatedContent: '',
      translationLanguage: '',
      translateTarget: messageApi.translateTarget(),
      pdfExporting: false,
    };
  },
  computed: {
    isResponseOwner() {
      return this.messageContent.answers[0].sender.itemid === this.user.accessId;
    },
    isResponseForMsg() {
      return this.messageContent.answers && this.messageContent.answers.length
        && !this.messageContent.confirmation && !this.messageContent.pool;
    },
    answerHasMessage() {
      return this.messageContent.received && !this.messageContent.confirmed_by
        && !this.messageContent.pool;
    },
  },
  methods: {
    setOpenStatus(status) {
      messageApi.changeStatus({ open: status }, this.$route.params.id).then(() => {
        this.messageContent.my_close_status = !status;
        this.show_data=false;
        this.$router.push('/show_message')
        this.$bus.refreshFeed();
      });
    },
    getMessage(state=null) {
      messageApi.show((data) => {
        this.messageContent = data.detailresponse;
        const confirmed = this.messageContent.confirmed ? this.messageContent.confirmed : 0;
		this.$bus.refreshCurrentMessage(this.$route.params.id, this.messageContent);
      }, this.$route.params.id);

      if(state){
        this.show_data=true;
      }
     // this.$bus.refreshUnreadedNo();
    },
    setPollResults(option) {
      this.selectedOption = option;
      if (option.contacts[0]) this.showPollResults = true;
    },
    selectAnswer(answer) {
      const answers = this.selectedAnswers;
      if (this.messageContent.multiple_choice) {
        // eslint-disable-next-line
        answers.includes(answer) ? answers.splice(answers.indexOf(answer), 1) : answers.push(answer);
      } else {
        // eslint-disable-next-line
        answers.includes(answer) ? answers.pop() : this.$set(answers, [0], answer);
      }
    },
    sendPollAnswer() {
      this.processing = true;

      messageApi.savePollChoices({ choices: this.selectedAnswers }, this.$route.params.id)
      .then(() => {
        this.processing = false;
        this.getMessage();
        // this.$bus.refreshFeed();
      });
    },
    sendAnswer() {
      this.processing = true;
      messageApi.new(this.answer, null, this.messageContent.itemid).then((response) => {
        this.processing = false;
        this.$refs.modalAnswerMessage.hide();
        this.getMessage();
        this.messageContent = response.data.detailresponse;
       // this.$bus.refreshFeed();
      });
    },
    clearModal() {
      this.answer.message = '';
    },
    openReply() {
      const messageReply = this.messageContent.answers[0];
      if (messageReply.unread) {
        messageApi.openReply(messageReply.itemid);
        messageReply.unread = false;
        //this.$bus.refreshFeed();
        this.$bus.refreshUnreadedNo();
      }
    },
    // In case translation is not working with emojis use emoji-strip or this regexp to replace emojis in a string:
    // /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g
    translate() {
      if (messageApi.translateTarget()) {
        const decoded = this.messageContent.message
          .replace(/\\u(....)/g, (match, p1) => String.fromCharCode(parseInt(p1, 16)))
          .replace(/\\(\d{3})/g, (match, p1) => String.fromCharCode(parseInt(p1, 8)));
        messageApi.translate('', this.translateTarget.language, decoded, (resp) => {
          this.translatedContent = resp;
          this.translationLanguage = messageApi.translateTarget;
        });
      } else {
        this.$refs.modalTranslationDialog.show();
      }
    },
    closeModal() {
      this.$refs.modalTranslationDialog.hide();
    },
    exportPdfLetter() {
        this.pdfExporting = true;
        this.$refs['modalPdfExport'].hide();
        messageApi.exportPdfLetter((data) => {
            this.pdfExporting = false;
        }, { messageid: this.$route.params.id });
    },
    exportPdfMessage() {
        this.pdfExporting = true;
        this.$refs['modalPdfExport'].hide();
        messageApi.exportPdfMessage((data) => {
            this.pdfExporting = false;
        }, { messageid: this.$route.params.id });
    },
  },
  watch: {
    '$route.params.id': function onRouteChange() {
      this.getMessage(true);
      this.translatedContent = '';
      this.showPollResults = false;
     // this.$bus.refreshUnreadedNo();
    },
  },
  created() {
    pinboardApi.show((data) => {
     this.pinboard = data.detailresponse;
    }, this.user.child);
    this.getMessage();
      refreshMessageIntervalId = setInterval(() => {
        this.getMessage();
      }, 60000);
  },
  beforeDestroy() {
    clearInterval(refreshMessageIntervalId);
  },
};

</script>



// WEBPACK FOOTER //
// src/components/Messages/Show/Index.vue